import { ROAS_STANDARD_DAYS } from '@/features/roas/constants/roas-days'
import {
  HIDDEN_BY_DEFAULT_DAY_ROAS,
  getDayRoasFieldName,
} from '@/components/roi/day-roas-utils'

/** Weekly-only extended ROAS horizons (not synced to Monthly / DR Baseline) */
export const WEEKLY_EXTENDED_ROAS_DAYS = [270, 360, 400]

export const WEEKLY_ROAS_DAYS = [
  ...ROAS_STANDARD_DAYS,
  ...WEEKLY_EXTENDED_ROAS_DAYS,
].sort((a, b) => a - b)

const WEEKLY_HIDDEN_DAY_ROAS = [
  ...HIDDEN_BY_DEFAULT_DAY_ROAS,
  ...WEEKLY_EXTENDED_ROAS_DAYS,
]

export function getWeeklyDefaultColumnVisibility() {
  return Object.fromEntries(
    WEEKLY_HIDDEN_DAY_ROAS.map((day) => [getDayRoasFieldName(day), false]),
  )
}

export function buildWeeklyNormalModeVisibility(columnIds) {
  const hiddenIds = new Set(
    WEEKLY_HIDDEN_DAY_ROAS.map(getDayRoasFieldName),
  )

  return Object.fromEntries(
    columnIds.map((id) => [id, !hiddenIds.has(id)]),
  )
}

export function buildWeeklyRoasModeVisibility(columnIds) {
  const visibleIds = new Set([
    'week',
    'installs',
    'costs',
    ...WEEKLY_ROAS_DAYS.map(getDayRoasFieldName),
  ])

  return Object.fromEntries(
    columnIds.map((id) => [id, visibleIds.has(id)]),
  )
}

export { WEEKLY_MIN_VALID_INSTALL_DAYS, isWeeklyRoasValueVisible } from '@/components/roi/day-roas-utils'

export const WEEKLY_VIEW_MODE_OPTIONS = [
  { id: 'normal', label: 'Normal mode' },
  { id: 'roas', label: 'Roas mode' },
]
